export var BillListStatus;
(function (BillListStatus) {
    BillListStatus["NeedsResolve"] = "NEEDS_RESOLVE";
    BillListStatus["Ready"] = "READY";
    BillListStatus["Reviewing"] = "REVIEWING";
    BillListStatus["NeedsConfirm"] = "NEEDS_CONFIRM";
    BillListStatus["Waiting"] = "WAITING";
    BillListStatus["Paid"] = "PAID";
})(BillListStatus || (BillListStatus = {}));
//# sourceMappingURL=bill-list-status.enum.js.map